// === ORION-CORE query-client ===
// Instância TanStack QueryClient independente de plataforma.
// Importar como: import { queryClientInstance } from '@/api/query-client'

import { QueryClient } from '@tanstack/react-query';

export const queryClientInstance = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: 1,
    },
  },
});